/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useCallback,
    useContext
} from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useModal } from '@jutro/components';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { FormModalPopover } from 'ml-components-platform-react';
import _ from 'lodash';
import modalPopoverUi from './MLHOSeparateStructsNotRentedPopover.metadata.json5';
import metadata from './MLHOSeparateStructsNotRentedComponent.metadata.json5';
import messages from './MLHOSeparateStructsNotRentedComponent.messages';

const SCHED_ITEM_TYPE = 'separateStructsNotRented';
const DTO_PATH = 'metlife.edge.capabilities.common.plugin.dto.HOPSeparateStructsNotRentedDTOML';

function MLHOSeparateStructsNotRentedComponent(props) {
    const modalApi = useModal();
    const {
        items,
        defaultItem,
        readOnly,
        loading,
        parentAddItemSaveHandler,
        parentEditItemSaveHandler,
        parentRemoveItemHandler,
        addressFormatter,
        resetChosenTermAndChosenTermValue,
        formatOptionAvailableVals
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);

    const editItemSaveHandler = useCallback((vm) => {
        return parentEditItemSaveHandler(vm, SCHED_ITEM_TYPE);
    }, [parentEditItemSaveHandler]);

    const addItemSaveHandler = useCallback((vm) => {
        return parentAddItemSaveHandler(vm, SCHED_ITEM_TYPE);
    }, [parentAddItemSaveHandler]);

    const getPopupProps = useCallback((vm, isEdit) => {
        return {
            title: messages.modalTitle,
            uiProps: modalPopoverUi.pageContent,
            actionBtnLabel: messages.continueBtn,
            viewModel: vm,
            getOverrideProps: () => {
                return {
                    structureTypeDropdownSelect: {
                        value: vm.structureType.chosenTerm.value,
                        availableValues: formatOptionAvailableVals(vm.structureType.options.value),
                        validationMessages: vm.structureType.chosenTerm.aspects.validationMessages
                    }
                };
            },
            onSaveAction: isEdit ? editItemSaveHandler : addItemSaveHandler
        };
    }, [addItemSaveHandler, editItemSaveHandler, formatOptionAvailableVals]);

    const getDefaultScheduleItem = useCallback(() => {
        const defaultSeparateStructNotRented = resetChosenTermAndChosenTermValue(defaultItem);
        return _.omit(defaultSeparateStructNotRented, ['fixedID', 'description']);
    }, [defaultItem, resetChosenTermAndChosenTermValue]);

    const onAddItem = useCallback(() => {
        const isEdit = false;
        const defaultVal = getDefaultScheduleItem();
        const vm = viewModelService.create(defaultVal, 'pc', DTO_PATH);
        const componentProps = getPopupProps(vm, isEdit);

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [getDefaultScheduleItem, getPopupProps, viewModelService]);

    const onEditItem = useCallback((evt) => {
        const isEdit = true;
        const selectedItem = items[evt.index];
        const selectedItemVm = viewModelService.create(selectedItem, 'pc', DTO_PATH);
        const componentProps = getPopupProps(selectedItemVm, isEdit);

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [getPopupProps, items, viewModelService]);

    const onRemoveItem = useCallback((evt) => {
        parentRemoveItemHandler(evt.index, SCHED_ITEM_TYPE);
    }, [parentRemoveItemHandler]);

    const getYesNo = (trueFalse) => {
        if (trueFalse === "true") {
            return "Yes"
        } else {
            return "No"
        }
    };


    const generateItemOverrides = useCallback(() => {
        const itemOverrides = items.map((item, itemIndex) => {
            return {
                [`actionRow${itemIndex}`]: {
                    visible: !readOnly,
                    className: loading ? 'cell disabled' : 'cell'
                }
            };
        });

        return Object.assign({}, ...itemOverrides);
    }, [addressFormatter, items, loading, readOnly]);

    const overrides = {
        stackTableDiv: {
            className: readOnly ? 'stack-table' : 'stack-table plain'
        },
        actionHeader: {
            visible: !readOnly
        },
        tableRowIterable: {
            data: items
        },
        bottomButtonContainer: {
            visible: !readOnly
        },
        addItemBtn: {
            visible: !readOnly,
            disabled: loading
        },
        ...generateItemOverrides()
    };


    const resolvers = {
        resolveCallbackMap: {
            onAddItem,
            onEditItem,
            onRemoveItem
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLHOSeparateStructsNotRentedComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    defaultItem: PropTypes.shape({}),
    readOnly: PropTypes.bool,
    loading: PropTypes.bool,
    parentAddItemSaveHandler: PropTypes.func,
    parentEditItemSaveHandler: PropTypes.func,
    parentRemoveItemHandler: PropTypes.func,
    addressFormatter: PropTypes.func,
    resetChosenTermAndChosenTermValue: PropTypes.func
};

export default MLHOSeparateStructsNotRentedComponent;
